import { useParams, useOutletContext, useNavigate } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import { FormGroup, Input, Label, Button, ButtonGroup, TabContent, TabPane } from 'reactstrap';

import {translations} from './../../i18/translations.js';
import ContentEditor from './../../util/contenteditor/ContentEditor.js';

const ContentManagementEdit = () => {

    const API_URL = process.env.REACT_APP_SERVICE_API_URL;
    const {user, lang, showAlert, checkAccess} = useOutletContext();
    const {id, parentId} = useParams();
    const navigate = useNavigate();

    const [featureList, setFeatureList] = useState([]);
    const [content, setContent] = useState([]);
    const [activeTab, setActiveTab] = useState("1");

    const contentHUEditorRef = useRef(null);
    const contentENEditorRef = useRef(null);

    const toggleTabPanel = (tab) => {
        if (activeTab !== tab) {
            setActiveTab(tab);
        }
    };

    const fetchData = async () => {
        try {
            const payload = {
                content: {
                    id: id,
                    parentId: parentId
                }
            };
            const response = await fetch(`${API_URL}/admin/get_content_data_by_id.php`, {
                method: "POST",
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify(payload)
            });
            const data = await response.json();
            if (checkAccess(data)) {
                setContent(data.content);
                setFeatureList(data.featureList);
            }
        } catch (error) {
            console.error("Error fetching content:", error);
        }
    };

    const getEditorValueAndSave = async() => {
        let textHU = await contentHUEditorRef.current.getValue();
        let textEN = await contentENEditorRef.current.getValue();

        setContent((prev) => {
            const newContent = {
                ...prev,
                text_hu: textHU,
                text_en: textEN
            };

            if (newContent.description_hu && newContent.description_en) {
                save(newContent);
            } else {
                showAlert({type: 'alert-danger', message: 'content_missing_description'});
            }
            return newContent;
        });
    };

    const save = async (content) => {
        try {
            const payload = {
                content: content
            };
            const response = await fetch(`${API_URL}/admin/save_content.php`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            });
            const data = await response.json();
            if (checkAccess(data)) {
                showAlert(data.alert);
                fetchData();
            }
        } catch (error) {
            console.error("Error save content:", error);
        }
    };

    const back = () => {
        navigate("/ContentManagement/" + parentId);
    };

    useEffect(() => {
        fetchData();
    }, [id, lang, user]);

    const handleContentChange = (e) => {
        const {id, value, type, checked} = e.target;
        setContent((prevData) => ({
                ...prevData,
                [id]: type === 'checkbox' ? checked : value
            }));
    };

    return (
            <div classname="mbkegy-content">
                <h1 className="mbkegy-content">{translations[lang].content_management}</h1>
            
                {content && <>
                <FormGroup floating>
                    <Input id="parent" type="text" rows="3" value={content.parent} disabled/>
                    <Label for="parent">{translations[lang].menu_parent}</Label>
                </FormGroup>
                <FormGroup floating>
                    <Input type="select" id="access_feature_id" value={content.access_feature_id} onChange={handleContentChange}>
                    <option key="" value="">{translations[lang].feature_access_none}</option>
                    {featureList.map((f, index) => (
                                        <option key={index} value={f.id}>[{f.id}] {f.name}</option>
                                                ))}
                    </Input>
                    <Label for="access_feature_id">{translations[lang].content_access}</Label>
                </FormGroup>
                <FormGroup floating>
                    <Input id="header_hu" type="text" rows="3" value={content.header_hu} onChange={handleContentChange}/>
                    <Label for="header_hu">{translations[lang].content_header} [HU]</Label>
                </FormGroup>
                <FormGroup floating>
                    <Input id="header_en" type="text" rows="3" value={content.header_en} onChange={handleContentChange}/>
                    <Label for="header_en">{translations[lang].content_header} [EN]</Label>
                </FormGroup>
                <FormGroup floating>
                    <Input id="title_hu" type="text" rows="3" value={content.title_hu} onChange={handleContentChange}/>
                    <Label for="title_hu">{translations[lang].content_title} [HU]</Label>
                </FormGroup>
                <FormGroup floating>
                    <Input id="title_en" type="text" rows="3" value={content.title_en} onChange={handleContentChange}/>
                    <Label for="title_en">{translations[lang].content_title} [EN]</Label>
                </FormGroup>
                <FormGroup floating>
                    <Input id="description_hu" type="text" rows="3" value={content.description_hu} onChange={handleContentChange}/>
                    <Label for="description_hu">{translations[lang].content_description} [HU]</Label>
                </FormGroup>
                <FormGroup floating>
                    <Input id="description_en" type="text" rows="3" value={content.description_en} onChange={handleContentChange}/>
                    <Label for="description_en">{translations[lang].content_description} [EN]</Label>
                </FormGroup>
            
                <FormGroup switch>
                    <Input id="logical_content" type="switch" checked={content.logical_content} onChange={handleContentChange}/>
                    <Label for="logical_content">{translations[lang].logical_content}</Label>
                </FormGroup>  
            
                <FormGroup floating>
                    <Input id="expired_time" type="date" value={content.expired_time} onChange={handleContentChange} />
                    <Label for="expired_time">{translations[lang].content_expired_time}</Label>
                </FormGroup>
            
            
            
            
            
                <ButtonGroup className="d-flex w-100 mb-1">
                    <Button
                        color="primary"
                        outline
                        onClick={() => toggleTabPanel("1")}
                        active={activeTab === "1"}
                        >
                        HU
                    </Button>
                    <Button
                        color="primary"
                        outline
                        onClick={() => toggleTabPanel("2")}
                        active={activeTab === "2"}
                        >
                        EN
                    </Button>
                </ButtonGroup>
            
            
            
                <TabContent activeTab={activeTab}>
                    <TabPane tabId="1">
                        <ContentEditor ref={contentHUEditorRef} id="content_hu" content={content.text_hu}  lang={lang} />
                    </TabPane>
            
            
                    <TabPane tabId="2">
                        <ContentEditor ref={contentENEditorRef} id="content_en" content={content.text_en}  lang={lang} />
                    </TabPane>
                </TabContent>
            
            
                <Button color="primary" title={translations[lang].anew} onClick={() => getEditorValueAndSave()}>{translations[lang].save}</Button>
                <Button  title={translations[lang].anew} onClick={() => back()}>{translations[lang].back}</Button>
            
                </>}
            
            
            
            </div>
            );
};

export default ContentManagementEdit;